function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { createPortal } from 'react-dom';
import ToastContext from './toast_context';
import ToastContainer from './toast_container';
import ToastNotification from '../toast_notification';
import { toastProviderPropTypes } from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ToastProvider = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    children,
    domRoot,
    newOnTop = true,
    position = 'bottom'
  } = _ref;
  var [toasts, setToasts] = React.useState([]);
  var toastsRef = React.useRef();
  React.useEffect(() => {
    toastsRef.current = toasts;
  }, [toasts]);
  var hasId = React.useCallback(id => {
    var {
      current: currentToasts
    } = toastsRef;
    if (!(Array.isArray(currentToasts) && currentToasts.length > 0)) return false;
    return currentToasts.findIndex(toast => toast.id === id) !== -1;
  }, [toastsRef]);
  var addToast = React.useCallback(toast => {
    if (hasId(toast.id)) return;
    setToasts(prevToasts => [...prevToasts, toast]);
  }, [hasId, setToasts]);
  var removeAllToasts = React.useCallback(() => setToasts(prevToasts => !prevToasts.length ? prevToasts : []), [setToasts]);
  var removeToast = React.useCallback(id => {
    if (typeof id === 'undefined') {
      removeAllToasts();
    } else {
      if (!hasId(id)) return;
      setToasts(prevToasts => prevToasts.filter(t => t.id !== id));
    }
  }, [removeAllToasts, hasId]);
  var updateToast = React.useCallback((id, options) => {
    if (!hasId(id)) return;
    setToasts(prevToasts => {
      var oldToasts = prevToasts;
      var index = oldToasts.findIndex(t => t.id === id);
      var updatedToast = _extends({}, oldToasts[index], options);
      return [...oldToasts.slice(0, index), updatedToast, ...oldToasts.slice(index + 1)];
    });
  }, [hasId, setToasts]);
  var renderedToasts = ___EmotionJSX(ToastContainer, {
    newOnTop: newOnTop,
    position: position,
    ref: ref
  }, toasts.map(toast => ___EmotionJSX(ToastNotification, _extends({
    key: toast.id,
    onClose: removeToast
  }, toast))));
  return ___EmotionJSX(ToastContext.Provider, {
    value: {
      addToast,
      removeToast,
      updateToast,
      toasts
    }
  }, children, domRoot ? /*#__PURE__*/createPortal(renderedToasts, domRoot) : renderedToasts);
});
ToastProvider.propTypes = toastProviderPropTypes;
ToastProvider.displayName = 'ToastProvider';
export default ToastProvider;